
import {IonContent, IonFooter, IonPage, IonItem, IonLabel, IonInput, modalController} from '@ionic/vue'
import {defineComponent, reactive, ref, computed} from 'vue'
import {onBeforeRouteLeave} from 'vue-router'
import {useStore} from 'vuex'
import LeftTopLogo from '../components/Common/LeftTopLogo.vue'
import SimpleLoginModal from '@/components/Modal/SimpleLoginModal.vue'

export default defineComponent({
  components: {
    IonContent,
    IonFooter,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    LeftTopLogo,
  },
  name: 'Login',
  setup() {
    const {dispatch} = useStore()

    const form = reactive({
      birthDate: '',
      name: '',
      phone: '',
    })
    const errorMessage = ref<string>('')
    const isLoading = ref<boolean>(false)

    const isFormValid = computed(() => {
      return form.name && form.phone && form.birthDate
    })

    const lookupUuid = async () => {
      if (!isFormValid.value) {
        errorMessage.value = '모든 정보를 입력해주세요'
        return
      }

      isLoading.value = true
      errorMessage.value = ''

      try {
        const result = await dispatch('user/ACT_LOOKUP_UUID', {
          birthDate: form.birthDate,
          name: form.name,
          phone: form.phone,
        })

        if (result && result.uuid) {
          // UUID 저장 완료 → 기존 SimpleLoginModal 열기
          const modal = await modalController.create({
            backdropDismiss: true,
            component: SimpleLoginModal,
            cssClass: 'simple-login-modal',
            id: 'SimpleLoginModal',
            keyboardClose: true,
            mode: 'ios',
            swipeToClose: true,
          })
          await modal.present()
        } else {
          errorMessage.value = '등록되지 않은 사용자입니다'
        }
      } catch (error: any) {
        errorMessage.value = error?.response?.data?.message || '로그인 실패. 다시 시도해주세요'
      } finally {
        isLoading.value = false
      }
    }

    onBeforeRouteLeave(() => {
      // cleanup
    })

    return {
      errorMessage,
      form,
      isFormValid,
      isLoading,
      lookupUuid,
    }
  },
})
